export default __webpack_public_path__ + "static/media/img_activedirectoryevl-colorBkg.81938e3b.png";